import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
    selector: 'ca-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SpinnerComponent {
    public diameter = input<number>(32);
    public text = input<string>();
    public subtext = input<string>();
    public transparent = input<boolean>(false);
    public small = input<boolean>(false);

    protected isText = computed(() => !!this.text() || !!this.subtext());
}
